import React, { useState } from 'react'
import DataTable from '../../../Components/UI/table/DataTable'
import NotificationModal from '../../../Components/systemsettings/notifications/NotificationModal'
import { useQuery } from 'react-query'
import { getNotifications } from '../../../MyApi/notifications'
import { Button } from 'reactstrap'
import HeaderBar from '../../../Components/UI/headerbar'

const Notifications = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const { data, isLoading, refetch, error } = useQuery(
    ['notifications', currentPage],
    () => getNotifications(currentPage),
    {
      keepPreviousData: true,
    }
  )

  const columns = [
    {
      label: 'العنوان',  
      accessor: "title",

    },
    {  
      label: 'النص',
      accessor: "body",

    },
    {
      label: 'النوع',
      accessor: "target_type",
  
    },
    {
      label: 'تاريخ الإرسال',
      accessor: "created_at",

    },
  
  ]

  const handleAddNotification = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div>
     
      <HeaderBar title={"الإشعارات والرسائل"} content={"إدارة الإشعارات والرسائل في نظام دايم"}/>
      <DataTable 
      title={"الإشعارات"}
        data={data?.data?.notifications || []} 
        columns={columns} 
        isLoading={isLoading}
        onAddClick={handleAddNotification}
        actionLabel={"إرسال اشعار اخر"}
        createPermission={"create_admin_notification"}
        pagination
        paginationTotalRows={data?.data?.total || 0}
        paginationPerPage={data?.data?.per_page || 10}
        paginationCurrentPage={currentPage}
        onChangePage={page => setCurrentPage(page)}
        error={error}
        onRetry={() => refetch()}
      />
      
      <NotificationModal 
        isOpen={isModalOpen} 
        closeModal={handleCloseModal} 
        refetch={refetch}
      />
    </div>
  )
}

export default Notifications 
